import React, { useRef, useState } from "react";
import { Stack, TextField, Typography, Button } from "@mui/material";
import ImagePickerDialog from "../ImagePickerDialog";

const normalizeOptions = (options) =>
    Array.isArray(options)
        ? options.map((o) => ({
            id: String(o?.id || "").trim(),
            text: String(o?.text || ""),
        }))
        : [];

const insertAtCursor = (input, value, text) => {
    if (!input) return (value || "") + text;

    const start = input.selectionStart ?? value.length;
    const end = input.selectionEnd ?? value.length;

    return value.slice(0, start) + text + value.slice(end);
};

const QuestionFormTest = ({ value, onChange }) => {
    const v = value || {};
    const options = normalizeOptions(v.options);

    const [pickerOpen, setPickerOpen] = useState(false);
    const questionRef = useRef(null);

    function updateOption(idx, patch) {
        const next = options.map((o, i) => (i === idx ? { ...o, ...patch } : o));
        onChange({ ...v, options: next });
    }

    function addOption() {
        const next = [...options, { id: "", text: "" }];
        onChange({ ...v, options: next });
    }

    function removeOption(idx) {
        const next = options.filter((_, i) => i !== idx);
        onChange({ ...v, options: next });
    }

    function onPickImage(img) {
        const caption = img.originalFilename || "Зображення";

        const block =
            `\n<figure style="text-align:center;">` +
            `\n  <img src="${img.url}" style="width:60%; max-width:100%; height:auto;" alt="${caption}" />` +
            `\n  <figcaption class="imgcaption">${caption}</figcaption>` +
            `\n</figure>\n`;

        const next = insertAtCursor(
            questionRef.current,
            v.question || "",
            block
        );

        onChange({ ...v, question: next });
        setPickerOpen(false);
    }

    return (
        <Stack spacing={2}>
            <TextField
                label="subtitle"
                value={v.subtitle || ""}
                onChange={(e) => onChange({ ...v, subtitle: e.target.value })}
                fullWidth
            />

            <TextField
                label="question (HTML)"
                value={v.question || ""}
                onChange={(e) => onChange({ ...v, question: e.target.value })}
                fullWidth
                multiline
                minRows={4}
                inputRef={questionRef}
            />

            <Button variant="outlined" onClick={() => setPickerOpen(true)}>
                ВСТАВИТИ ЗОБРАЖЕННЯ
            </Button>

            <TextField
                label="imgPath"
                value={v.imgPath || ""}
                onChange={(e) => onChange({ ...v, imgPath: e.target.value })}
                fullWidth
            />

            <TextField
                label="videoPath"
                value={v.videoPath || ""}
                onChange={(e) => onChange({ ...v, videoPath: e.target.value })}
                fullWidth
            />

            <TextField
                label="addClass"
                value={v.addClass || ""}
                onChange={(e) => onChange({ ...v, addClass: e.target.value })}
                fullWidth
            />

            <TextField
                label="correctAnswer"
                value={v.correctAnswer || ""}
                onChange={(e) => onChange({ ...v, correctAnswer: e.target.value })}
                placeholder="A / Б / В / Г або 1 / 2 ..."
                fullWidth
            />

            <Typography variant="subtitle2" sx={{ mt: 1 }}>
                options
            </Typography>

            {options.map((opt, idx) => (
                <Stack key={idx} direction={{ xs: "column", sm: "row" }} spacing={1}>
                    <TextField
                        label="id"
                        value={opt.id}
                        onChange={(e) => updateOption(idx, { id: e.target.value })}
                        sx={{ width: { sm: 120 } }}
                    />
                    <TextField
                        label="text (HTML)"
                        value={opt.text}
                        onChange={(e) => updateOption(idx, { text: e.target.value })}
                        fullWidth
                    />
                    <TextField
                        value="✕"
                        onClick={() => removeOption(idx)}
                        sx={{
                            width: { sm: 60 },
                            "& input": { cursor: "pointer", textAlign: "center" },
                        }}
                        inputProps={{ readOnly: true }}
                    />
                </Stack>
            ))}

            <TextField
                value="+ add option"
                onClick={addOption}
                inputProps={{ readOnly: true }}
                sx={{ "& input": { cursor: "pointer" } }}
            />

            <ImagePickerDialog
                open={pickerOpen}
                onClose={() => setPickerOpen(false)}
                onPick={onPickImage}
            />
        </Stack>
    );
};

export default QuestionFormTest;